import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function LandingFooter() {
  return (
    <footer className="relative bg-dark-primary border-t border-dark-border/30 pt-32 pb-12 overflow-hidden">
      <div className="pointer-events-none absolute inset-0 opacity-20">
        <video className="h-full w-full object-cover" autoPlay loop muted playsInline>
          <source src="/vapi-pattern.mp4" type="video/mp4" />
        </video>
      </div>
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-dark-primary/50 via-transparent to-dark-primary" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center">
          
        {/* Huge Logo Watermark */}
        <div className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 pointer-events-none select-none opacity-[0.03]">
            <h1 className="text-[40vw] font-black text-text-primary leading-none">SuBs</h1>
        </div>

        <div className="relative z-10 mb-24 max-w-2xl">
             <h3 className="text-4xl md:text-6xl font-black font-outfit text-text-primary mb-8 uppercase tracking-tighter">
                Ready to <br/><span className="text-golden-accent">Scale?</span>
            </h3>
            <p className="text-xl text-text-secondary font-light mb-10">
                Join hundreds of creators monetizing their community on autopilot.
            </p>
            <Link
              to="/register/admin"
              className="inline-flex items-center gap-3 px-10 py-5 bg-golden-accent text-dark-primary font-bold rounded-full text-lg hover:scale-105 active:scale-95 transition-all uppercase tracking-wide hover:shadow-[0_0_40px_rgba(255,188,6,0.3)]"
            >
              Register Now <ArrowRight size={20} />
            </Link>
        </div>

        <div className="relative z-10 w-full flex flex-col md:flex-row items-center justify-between gap-6 border-t border-dark-border/50 pt-8">
            <p className="text-text-secondary text-sm">
                © {new Date().getFullYear()} SuBs. All rights reserved.
            </p>
            <div className="flex items-center gap-8">
                 <Link to="/terms" className="text-text-secondary hover:text-golden-accent text-sm transition-colors">Terms of Service</Link>
                 <Link to="/privacy" className="text-text-secondary hover:text-golden-accent text-sm transition-colors">Privacy Policy</Link>
                 <Link to="/support" className="text-text-secondary hover:text-golden-accent text-sm transition-colors">Support</Link>
            </div>
        </div>

      </div>
    </footer>
  );
}
